"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zh = void 0;
var zh = {
  mhForm: {
    required: '%l不能为空',
    min: '%l不能小于%v',
    max: '%l不能大于%v',
    minLen: '%l长度不能小于%v',
    maxLen: '%l长度不能大于%v',
    isPhone: '%l不是手机号格式',
    pattern: '%l格式不正确',
    isEmail: '%l不是邮箱格式'
  }
};
exports.zh = zh;